import { Input_Template_Switch, Output_Template_Finish } from '..';
import { ModuleIOValueTypeEnum, ModuleInputKeyEnum, ModuleTemplateTypeEnum } from '../../constants';
import { FlowNodeInputTypeEnum, FlowNodeTypeEnum } from '../../node/constants';
import { FlowModuleTemplateType } from '../../types';

export const OutputCardModule: FlowModuleTemplateType = {
  id: 'outputCard',
  templateType: ModuleTemplateTypeEnum.output,
  flowType: FlowNodeTypeEnum.cardOutput,
  name: '消息输出-分享卡片',
  description: '发送消息到回调地址',
  inputs: [
    Input_Template_Switch,
    {
      label: 'chatId',
      valueType: ModuleIOValueTypeEnum.string,
      type: FlowNodeInputTypeEnum.hidden,
      key: 'chatId',
      required: true,
      value: '{chatId}',
    },
    {
      label: '回调地址',
      valueType: ModuleIOValueTypeEnum.string,
      type: FlowNodeInputTypeEnum.select,
      key: 'outputUrl',
      required: true,
      list: [
        { label: '企微侧边栏', value: 'xxxx' },
        { label: '用户消息', value: 'xxxx' },
      ],
    },
    {
      label: '卡片头图名称',
      valueType: ModuleIOValueTypeEnum.string,
      type: FlowNodeInputTypeEnum.selectedMaterial,
      key: 'name',
      required: true,
    },
    {
      label: '卡片标题',
      valueType: ModuleIOValueTypeEnum.string,
      type: FlowNodeInputTypeEnum.input,
      key: 'title',
      required: true,
    },
    {
      label: '卡片描述内容',
      valueType: ModuleIOValueTypeEnum.string,
      type: FlowNodeInputTypeEnum.textarea,
      key: 'description',
      required: true,
    },
    {
      label: '卡片链接',
      valueType: ModuleIOValueTypeEnum.string,
      type: FlowNodeInputTypeEnum.input,
      key: 'url',
      required: true,
    },
    {
      label: '添加自定义key',
      valueType: ModuleIOValueTypeEnum.string,
      type: FlowNodeInputTypeEnum.addInputParam,
      key: ModuleInputKeyEnum.addTemplate,
      edit: false,
      editField: {
        dataType: true,
        key: true,
        required: true,
      },
      defaultEditFieldValue: {
        valueType: 'string',
        required: true,
      },
      showTargetInApp: false,
      showTargetInPlugin: false,
    },
  ],
  outputs: [Output_Template_Finish],
};
